<form (ngSubmit)="save()" [formGroup]="form">
  <base-form-header
    [mode]="mode"
    createLabel="Créer une charge annuelle"
    updateLabel="Modifier la charge annuelle"
  ></base-form-header>
  <mat-dialog-content fxLayout="column">
    <base-form-input
      label="Année"
      controlName="year"
      type="number"
      [maxNumber]="9999"
      customErrorMessage="L'année doit contenir 4 chiffres"
    ></base-form-input>
    <base-form-input label="Montant annuel à répartir (€)" controlName="amount" type="number"></base-form-input>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <base-form-input
      type="submit"
      [mode]="mode"
      entityLabel="CHARGE"
      (onUpdate)="save()"
      (onCreate)="save()"
    ></base-form-input>
  </mat-dialog-actions>
</form>
